import axiosInstance from './axiosInstance';

export const getAllRoleRights = () =>
    axiosInstance.get("/RoleRight/GetAllRoleRights");

export const updateRoleRight = (request) =>
    axiosInstance.put("/RoleRight/UpdateRoleRight", request);

export const getAllRoles = () =>
    axiosInstance.get("/RoleRight/GetAllRoles");

export const getAllRights = () =>
    axiosInstance.get("/RoleRight/GetAllRights");

export const getUserRights = (userId) =>
    axiosInstance.get(`/RoleRight/GetUserRights?userId=${userId}`);

export const updateUserRight = (request) =>
    axiosInstance.put("/RoleRight/UpdateUserRight", request);
